import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";

import { Skeleton } from "../ui/skeleton";

// The workspace holds the chat kit (assistant-ui), which is about a third of a megabyte. It loads when a staff member opens the concierge
// pages, so the other pages of the console do not carry it.
const ConversationsWorkspace = lazy(() =>
  import("./Workspace").then((module) => ({ default: module.ConversationsWorkspace })),
);

/**
 * The concierge routes, mounted at `/concierge/*` (CHT-732):
 *   /concierge                   the workspace with no conversation open
 *   /concierge/:conversationId   the workspace with one conversation open (`?filter=` keeps the inbox filter)
 * One route with an optional parameter, so opening a conversation does not remount the workspace and the Stream connection stays.
 */
export function ConversationsRoutes() {
  return (
    <Routes>
      <Route
        path=":conversationId?"
        element={
          <Suspense
            fallback={
              <div role="status" aria-label="Loading the concierge workspace" className="p-4">
                <Skeleton className="h-32" />
              </div>
            }
          >
            <ConversationsWorkspace />
          </Suspense>
        }
      />
    </Routes>
  );
}
